import { UPDATE_GROUP_NAME, UPDATE_PARTY } from '../actions/groupDetails'
import { RESET_FLOW } from '../actions/reset'

export const initialState = {
  groupName: '',
  party: [
    {
      key: 'adults',
      label: '',
      hint: '> 11 ',
      value: 0,
      minValue: 1,
      maxValue: 189,
      required: true,
    },
    {
      key: 'children',
      label: '',
      hint: '2 - 11 ',
      value: 0,
      minValue: 0,
      maxValue: 50,
      required: false,
    },
    {
      key: 'babies',
      label: '',
      hint: '< 2 ',
      value: 0,
      minValue: 0,
      maxValue: 30,
      required: false,
    },
  ],
}

function groupDetails(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_GROUP_NAME:
      return {
        ...state,
        groupName: action.groupName,
      }
    case UPDATE_PARTY:
      return {
        ...state,
        party: action.party,
      }
    case RESET_FLOW:
      return initialState
    default:
      return state
  }
}

export default groupDetails
